import * as React from "react";
import { Box, TextField } from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { createTheme } from "@mui/material/styles";
import { ThemeProvider } from "@emotion/react";
import { useSelector } from "react-redux";

export default function DateRange({
  startDateHandler = () => {},
  endDateHandler = () => {},
}) {
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          root: {
            top: "-7px",
            fontSize: "1.2rem",
          },
        },
      },
    },
  });

  const DatePickerStyle = {
    overflow: "hidden",
    backgroundColor: "#FAFAFA",
    width:"95%",
    borderRadius: "4px",
    paddingLeft: "0.5rem",
    marginLeft: "0.6rem",
    ".MuiInputBase-input": {
      fontSize: "1.2rem",
      padding: "1rem 0.2rem",
    },
    "& .MuiInputBase-root": {
      height: "auto",
      paddingRight: 0,
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "none",
      },
      "&:hover fieldset": {
        border: "none",
      },
      "&.Mui-focused fieldset ": {
        border: "none",
      },
      "& .MuiButtonBase-root": { padding: 0, marginRight: "0.3rem" },
    },
  };
  const { startDate, endDate } = useSelector((state) => state.FilterSlice.date);
  const sideBarClickedTabName = useSelector((state) => state.sidBarSliceMenu.sideBarMenu)
  const {  approvalStartDate,approvalEndDate} = useSelector((state) => state.FilterSlice.approvalDate)
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer
        components={["DatePicker"]}
        sx={{ mb: "1rem", mt: "1rem", pt: 0 }}
      >
        <Box>
          <ThemeProvider theme={theme}>
            <DatePicker
              label="From"
              value={ sideBarClickedTabName === "Approval" ? approvalStartDate :startDate}
              sx={DatePickerStyle}
              onChange={startDateHandler}
            />
          </ThemeProvider>
        </Box>
        <Box>
          <ThemeProvider theme={theme}>
            <DatePicker
              value={sideBarClickedTabName  === "Approval" ? approvalEndDate : endDate}
              label="To"
              sx={DatePickerStyle}
              onChange={endDateHandler}
            />
          </ThemeProvider>
        </Box>
      </DemoContainer>
    </LocalizationProvider>
  );
}
